import { useSelector } from "react-redux";
import { CartProduct } from "../interfaces/Cart";
import { StoreState } from "../interfaces/storeState";

export const useCartProduct = (): CartProduct => useSelector(getCartProduct);

const getCartProduct = (state: StoreState): CartProduct => {
  if (!state.cart?.product) {
    return undefined;
  }

  return state.cart.product;
};
